/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Characters_LabelInputs */

const en_dialog_text_to_audio_characters_label = /** @type {(inputs: Dialog_Text_To_Audio_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`characters`)
};

const es_dialog_text_to_audio_characters_label = /** @type {(inputs: Dialog_Text_To_Audio_Characters_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caracteres`)
};

/**
* | output |
* | --- |
* | "characters" |
*
* @param {Dialog_Text_To_Audio_Characters_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_characters_label = /** @type {((inputs?: Dialog_Text_To_Audio_Characters_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Characters_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_characters_label(inputs)
	return en_dialog_text_to_audio_characters_label(inputs)
});